Ext.define('WindowHelp', {
    extend: 'Ext.ux.window.WindowExd',
    title: Lang.header_help,
    width: 700,
    height: 700,
    closable: false,
    collapsible: false,
    modal: true,
    resizable: false,
    scrollable: false,
    layout: 'fit',
    src: 'example.com',
    initComponent: function () {
        this.cid = Ext.id();
        this.fzitems = [{
            itemId: 'company-form',
            frame: false,
            border: false,
            bodyCls: "custom-body-form-panel",
            scrollable: 'y',
            defaults: {
                anchor: '90%',
            },
            items: [{
                layout: "column",
                frame: false,
                scrollable: false,
                border: false,
                defaults: {
                    columnWidth: 1,
                },
                items: [{
                    layout: 'anchor',
                    frame: false,
                    border: false,
                    scrollable: false,
                    defaults: {
                        responsiveConfig: ResponsiveLabelAlignConfig,
                        anchor: '100%',
                    },
                    items: [{
                        itemId: 'nazwa',
                        xtype: 'textfieldexd',
                        fieldLabel: Lang.firma_zarzadzajaca,
                        editable: false
                    }, {
                        itemId: 'telefon',
                        xtype: 'textfieldexd',
                        fieldLabel: Lang.telefon,
                        editable: false
                    }, {
                        itemId: 'email',
                        xtype: 'textfieldexd',
                        fieldLabel: Lang.email,
                        editable: false
                    }, {
                        fieldLabel: Lang.opis,
                        isFormField: true,
                        height: 100,
                        itemId: "opis",
                        name: "opis",
                        xtype: 'textareaexd',
                        editable: false
                    }, {
                        xtype: 'component',
                        html: '<a href="/swagger-ui/index.html" target="_blank">>> SWAGGER-UI <<</a>',
                        cls: 'swagger-link'
                    }]
                }]
            }]
        }];
        this.items = [{
            xtype: 'panel',
            items: [{
                xtype: 'panel',
                items: this.fzitems
            }, {
                xtype: 'box',
                autoEl: {
                    tag: 'iframe',
                    src: this.src,
                    width: 700,
                    height: 320
                }
            }]
        }];
        this.buttons = [{
            xtype: 'tbfill'
        }, {
            id: this.cid + 'close',
            text: Lang.zamknij,
            ui: 'btn-secondary-s',
            scope: this,
            handler: this.closeOp
        }];
        this.callParent(arguments);
    },
    showW: function () {
        this.show();
        this.center();
        this.fillFields();
        this.setKeyMap({
            'ESC': {
                scope: this,
                handler: this.closeOp
            }
        });
    },
    fillFields: function () {
        performAjaxLPromise('rest/firmy/getInfoAboutFZForCurrentFirm', {}).then(data => {
            this.obiekt = data;
            this.down('#nazwa').setValue(this.obiekt.nazwa);
            this.down('#telefon').setValue(this.obiekt.telefon);
            this.down('#email').setValue(this.obiekt.email);
            this.down('#opis').setValue(this.obiekt.opis);
        });
    },
    closeOp: function () {
        this.close();
    }
});
